import React from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import { Badge } from 'react-bootstrap';
import { FaClock, FaRoad } from 'react-icons/fa';
import { normalizeModeCompteur } from '../utils/normalize';

const formatDateDisplay = (value) => {
  if (!value) return '—';
  return value;
};

const formatNumberDisplay = (value) => {
  if (value === null || value === undefined || value === '') return '—';
  const n = Number(value);
  if (!Number.isFinite(n)) return value;
  return n;
};

const formatCompteurDisplay = (value, mode) => {
  const n = formatNumberDisplay(value);
  if (n === '—') return n;
  const unit = normalizeModeCompteur(mode) === 'km' ? 'km' : 'h';
  return `${n} ${unit}`;
};

const getHistoriqueCycle = (row) => {
  const mode = normalizeModeCompteur(row?.mode_compteur);

  if (mode === 'km') {
    return formatCompteurDisplay(row?.compteur_vidange_km, mode);
  }

  return formatCompteurDisplay(row?.compteur_vidange_h, mode);
};

const getHistoriqueInterval = (row) => {
  const mode = normalizeModeCompteur(row?.mode_compteur);

  if (mode === 'km') {
    return formatCompteurDisplay(row?.interval_vidange_km, mode);
  }

  return formatCompteurDisplay(row?.interval_vidange_h, mode);
};

const VidangeHistoriqueTable = ({ rows = [] }) => {
  const columns = [
    {
      dataField: 'id',
      text: 'ID',
      sort: true,
      filter: textFilter({ placeholder: 'ID...' }),
      headerStyle: { width: '80px' }
    },
    {
      dataField: 'date_vidange',
      text: 'Date vidange',
      sort: true,
      filter: textFilter({ placeholder: 'AAAA-MM-JJ...' }),
      formatter: (cell) => formatDateDisplay(cell)
    },
    {
      dataField: 'matricule',
      text: 'Matricule',
      sort: true,
      filter: textFilter({ placeholder: 'Matricule...' }),
      formatter: (cell) => cell || '—'
    },
    {
      dataField: 'chantier_actuel',
      text: 'Chantier',
      sort: true,
      filter: textFilter({ placeholder: 'Chantier...' }),
      formatter: (cell) => cell || '—'
    },
    {
      dataField: 'mode_compteur',
      text: 'Mode',
      sort: true,
      filter: textFilter({ placeholder: 'h / km...' }),
      formatter: (cell) => {
        const mode = normalizeModeCompteur(cell);

        return mode === 'km' ? (
          <Badge bg="primary">
            <FaRoad className="me-1" />
            KM
          </Badge>
        ) : (
          <Badge bg="info" text="dark">
            <FaClock className="me-1" />
            Heure
          </Badge>
        );
      }
    },
    {
      dataField: 'cycle_historique',
      text: 'Cycle enregistré',
      sort: false,
      formatter: (_, row) => getHistoriqueCycle(row)
    },
    {
      dataField: 'interval_historique',
      text: 'Intervalle',
      sort: false,
      formatter: (_, row) => getHistoriqueInterval(row)
    },
    {
      dataField: 'observation',
      text: 'Observation',
      sort: true,
      filter: textFilter({ placeholder: 'Observation...' }),
      formatter: (cell) => cell || '—'
    }
  ];

  return (
    <div style={{ minWidth: '1100px' }}>
      <BootstrapTable
        keyField="id"
        data={rows}
        columns={columns}
        pagination={paginationFactory({
          sizePerPage: 10,
          sizePerPageList: [
            { text: '10', value: 10 },
            { text: '20', value: 20 },
            { text: '50', value: 50 }
          ],
          showTotal: true,
          alwaysShowAllBtns: true
        })}
        filter={filterFactory()}
        striped
        hover
        condensed
        bordered={false}
        noDataIndication="Aucun historique de vidange"
        wrapperClasses="table-responsive"
      />
    </div>
  );
};

export default VidangeHistoriqueTable;